import React, { useEffect } from 'react'
import {
    Inject,
    ChartComponent,
    SeriesCollectionDirective,
    SeriesDirective,
    Tooltip,
    Category,
    Legend,
    StackingColumnSeries,
    DataLabel
} from '@syncfusion/ej2-react-charts';

import "../Tables/Customs/syncfusion-grid-overrides.css";
import "@syncfusion/ej2-base/styles/bootstrap5.css";
import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "@syncfusion/ej2-popups/styles/bootstrap5.css";
import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
import "@syncfusion/ej2-grids/styles/bootstrap5.css";
import "../../../styles/chartResponsive.css";

import { useTheme } from '../../../contexts/ThemeContext';

export const ChartStackingColumns = (props) => {
    const { isDark } = useTheme();
    // Aplicar cores das labels baseadas no tema
    useEffect(() => {
        const chartElement = document.getElementById(props.id);
        if (chartElement) {
            const labels = chartElement.querySelectorAll('.e-chart-datalabel-text');
            labels.forEach(label => {
                label.style.fill = isDark ? '#ffffff' : '#000000';
                label.style.color = isDark ? '#ffffff' : '#000000';
            });
        }
    }, [isDark, props.id]);


    return (
        <div className="chart-container chart-stacking-container">
            <ChartComponent
                id={props.id}
                width={'100%'}
                height={'100%'}
                chartArea={{ border: { width: 0 } }}
                margin={{ left: 0, right: 0, top: 0, bottom: 40 }}
                primaryXAxis={{
                    valueType: "Category",
                    title: "",
                    labelRotation: props.labelRotation || 0,
                    titleStyle: { color: isDark ? '#ffffff' : '#000000', size: "10px" },
                    labelStyle: { color: isDark ? '#ffffff' : '#000000', size: "10px" }
                }}
                primaryYAxis={{
                    titleStyle: { color: isDark ? '#ffffff' : '#000000', size: "10px" },
                    labelStyle: { color: isDark ? '#ffffff' : '#000000', size: "10px" },
                    labelFormat: props.isMinutes ? `{value} h` : `{value} ${props.suffix || ''}`,
                }}
                tooltip={{
                    enable: true,
                    fill: '#000',  // fundo branco sempre
                    textStyle: { color: '#fff' }, // texto preto
                    border: { width: 1, color: '#ccc' },
                    titleStyle: { color: '#fff' }
                }}
                legendSettings={{
                    visible: true,
                    position: "Bottom",  // pode ser "Bottom", "Top", "Right", "Left"
                    width: "100%",       // ocupa a largura toda
                    height: "25px",      // aumenta espaço se precisar
                    textStyle: { color: isDark ? "#FFF" : "#000", size: "10px" },
                    rowCount: 2,               // força quebrar em 2 linhas se não couber
                    maximumLabelWidth: 180 
                  }}
                style={{ width: '100%', height: '100%', minHeight: '300px' }}
            >
                <Inject services={[StackingColumnSeries, Category, Tooltip, Legend, DataLabel]} />
                <SeriesCollectionDirective>
                    <SeriesDirective
                        type="StackingColumn"
                        dataSource={props.data}
                        xName={props.xName1}
                        yName={props.yName1}
                        name={props.name1}
                        fill={props.fill1}
                        dataLabel={{ visible: true, position: "Inside" }}
                    />
                    <SeriesDirective
                        type="StackingColumn"
                        dataSource={props.data}
                        xName={props.xName2}
                        yName={props.yName2}
                        name={props.name2}
                        fill={props.fill2}
                        dataLabel={{ visible: true, position: "Inside" }}
                    />
                    {props.categorys > 2 && (
                        <SeriesDirective
                            type="StackingColumn"
                            dataSource={props.data}
                            xName={props.xName3}
                            yName={props.yName3}
                            name={props.name3}
                            fill={props.fill3}
                            dataLabel={{ visible: true, position: "Inside" }}
                        />
                    )}
                    {props.categorys > 3 && (
                        <SeriesDirective
                            type="StackingColumn"
                            dataSource={props.data}
                            xName={props.xName4}
                            yName={props.yName4}
                            name={props.name4}
                            fill={props.fill4}
                            dataLabel={{ visible: true, position: "Inside" }}
                        />
                    )}
                </SeriesCollectionDirective>


            </ChartComponent>
        </div>
    )
}